export default __webpack_public_path__ + "static/media/pills@2x.385c6fa4.png";